import { QuestionResponses } from './QuestionResponses/QuestionResponses';

export const FormResponses = ({ fields }) => {
  return (
    <div className="bg-slate-50 flex flex-col gap-8 p-8">
      {fields.map((field, index) => (
        <QuestionResponses key={field.id} order={index + 1} field={field} params={{}} />
      ))}
    </div>
  );
};
